import {Injectable} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import {Observable} from 'rxjs';

interface UiConfig {
  header_color: string;
  background_color: string;
  background_text_color: string;
  background_gradient_color: string;
  primary_color: string;
  primary_text_color: string;
  header_text_color: string;
}

interface ExpirationInfo {
  language: string;
  text: string;
}

interface Wingame {
  id: number;
  title: string;
  event: {
    id_event: number;
    name: string;
  };
  start: string;
  end: string;
  min_age: number;
  expiration_info: any;
  sponsor_name: string;
  sponsor_photo: string;
  sponsor_link: string;
  is_exclusive: boolean;
  limit_to_one_play: boolean;
  included_in_newsletter: boolean;
  ui_config: UiConfig;
  status: string;
  event_id: number;
  photo: string;
  address: number;
  distance_km: number;
  game_over_image: string;
  game_over_url: string;
  is_interested_after_losing_game: boolean;
  custom_card_image: string;
  hidden_wingame: boolean;
  uuid: string;
  game_over_video_url: string;
  game_over_video_name: string;
  deeplink?: string;
}

@Injectable({
  providedIn: 'root',
})
export class WingameService {
  headers: HttpHeaders;
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
  ) {
    const csrfToken = this.cookieService.get('csrftoken');
    // const csrfToken = "TdL34a1r1csG7Arl5dU4gMErbr4hvB7W";

    this.headers = new HttpHeaders({
      'X-Csrftoken': csrfToken,
      Cookie: `csrftoken=${csrfToken}`,
    });
  }

  // TODO example needs to be finished
  uploadPhoto(file: File, reportProgress = true): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('files', file);

    const req = new HttpRequest('POST', `/rest-api/v2/admin/upload-image`, formData, {reportProgress});
    return this.http.request(req);
  }

  //TODO
  getWinningPercentage = (step: number) =>
    this.http.get<Wingame>(`/rest-api/v2/admin/win-games/populatiry_EXAMPLE${step}`);

  saveWinGame(body: any) {
    // I think those options are obsolete
    const options = {headers: this.headers, withCredentials: true};
    return this.http.post('/rest-api/v2/admin/win-games', body, options);
  }

  getDetails = (id: number) => this.http.get<Wingame>(`/rest-api/v2/admin/win-games/${id}`);
  updateWingame = (id: number, body: any) => this.http.put(`/rest-api/v2/admin/win-games/${id}`, body);

  getWinGamePrizeSettings = (id: number) => this.http.get<any>(`/rest-api/v2/admin/win-games/${id}/prize_settings`);
  savePrizeSettings = (id, body) => this.http.post(`/rest-api/v2/admin/win-games/${id}/prize_settings`, body);
  uploadPrizeFilePrizeSettings = (id, body, prizeId) =>
    this.http.put<any>(`/rest-api/v2/admin/win-games/${id}/prize_settings/${prizeId}`, body);
  saveNotificationsSettings = (id, body) => this.http.post(`/rest-api/v1/admin/target-audience/notifications`, body);

  publishWingame = id => this.http.post(`/rest-api/v2/admin/win-games/${id}/publish`, {});
  getUploadStatus = (id: number) =>
    this.http.get<any>(`/rest-api/admin-panel/api/v1/admin/win-games/${id}/mobile_tickets`);

  getWingamesWinners = (id: number) => this.http.get<any>(`/rest-api/v2/admin/win-games/${id}/winners`);
  exportWinnersCsv = (id: number) => this.http.get<any>(`/rest-api/v2/admin/win-games/${id}/export-winners`);

  //TODO change to proper endpoints
  getWinGameNotificationsSettings = (id: number) => this.http.get(`/rest-api/v2/admin/win-games/${id}/prize_settings`);
}
